import { render, staticRenderFns } from "./PersonhistDetails.vue?vue&type=template&id=7e33b9bb&"
import script from "./PersonhistDetails.vue?vue&type=script&lang=js&"
export * from "./PersonhistDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports